import { configureStore, combineSlices, EnhancedStore } from '@reduxjs/toolkit';
import { isDevelopment } from './constants';
import { baseApiAuthenticated } from '@/api/v2';
import { authMiddleware } from '@/middleware/authMiddleware';
import { registerStore } from '@starjack/api';
import { authSlice } from '@starjack/features/authentication';
import { pageDataSlice } from '@starjack/features/pageData';

export const rootReducer = combineSlices(
    baseApiAuthenticated,
    authSlice,
    pageDataSlice
);

// Wrap with clearAuthData logic
const finalReducer = (state, action) => {
    if (action.type === 'authSlice/clearAuthData') {
        return {
            ...rootReducer(undefined, action),
        };
    }

    return rootReducer(state, action);
};

export type Store = Parameters<typeof rootReducer>[0];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const store: EnhancedStore<Store, any, any> = configureStore({
    reducer: finalReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
            immutableCheck: false,
        }).concat(authMiddleware, baseApiAuthenticated.middleware),

    devTools: isDevelopment,
});

// fetchAuthWrapper reads the token from here
registerStore(store);
